export const FILTER_STATUS_ID_MAP = {
  priced: 8,
  launched: 5,
  guidance: 4,
  announced: 1,
  premarketing: 11,
  mandate: 6,
  rumor: 9,
  '15-g': 10,
  postponed: 7,
  cancelled: 2,
  filed: 3,
  ipt: 12,
  spreadSet: 13,
};
